// extracted by mini-css-extract-plugin
export default {"root":"SimpleTable-module--root--d44c4"};